import { IxGrid } from './IxGrid.js';

window.customElements.define('ix-grid', IxGrid);
